module.exports = __webpack_public_path__ + "static/media/humming-bird.febfa959.svg";